import { Building2 } from 'lucide-react';
import { Link, Navigate } from 'react-router-dom';

import { EmptyState } from '@/components/common/empty-state';
import { PageHeader } from '@/components/common/page-header';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuthStore } from '@/stores/auth-store';

export function HomePage() {
  const user = useAuthStore((s) => s.user);

  if (user?.isSuperAdmin) {
    return <Navigate to="/super-admin/dashboard" replace />;
  }

  const memberships = user?.memberships ?? [];

  if (memberships.length === 1) {
    const only = memberships[0];
    if (only) {
      return <Navigate to={`/o/${only.organizationSlug}/dashboard`} replace />;
    }
  }

  return (
    <div className="mx-auto w-full max-w-5xl p-6">
      <PageHeader
        title={`Welcome${user?.name ? `, ${user.name.split(' ')[0]}` : ''}`}
        description="Pick an organization to continue."
      />

      {memberships.length === 0 ? (
        <EmptyState
          icon={Building2}
          title="You haven't joined any organization"
          description="Ask a super admin to invite your organization, or an existing org admin to invite you."
        />
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {memberships.map((m) => (
            <Card key={m.organizationId}>
              <CardHeader>
                <CardTitle className="text-base">{m.organizationName}</CardTitle>
              </CardHeader>
              <CardContent className="flex items-center justify-between">
                <span className="text-xs text-muted-foreground">{m.roleName}</span>
                <Button asChild size="sm">
                  <Link to={`/o/${m.organizationSlug}/dashboard`}>Open</Link>
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
